import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X, Home, CalendarDays, Plus, Heart, CircleUserRound, Gem } from "lucide-react";

const LINKS = [
  ["home", "Accueil", "/", Home, true],
  ["events", "Événements", "/events", CalendarDays],
  ["instant", "Créer mon Instant", "/instant", Plus],
  ["reservations", "Mes réservations", "/reservations", Heart],
  ["experiences", "Nos expériences", "/experiences", Gem],
  ["account", "Mon compte", "/account", CircleUserRound],
];

export const DesktopNav = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  return (
    <div className="hidden md:block">
      <button data-testid="side-menu-button" aria-label="Ouvrir le menu" onClick={() => setOpen(true)}
        className="fixed left-6 top-[calc(var(--safe-top)+24px)] z-40 flex h-12 w-12 items-center justify-center rounded-full border border-[#E6A45D]/50 bg-[#090806]/80 text-[#F8C872] backdrop-blur-xl transition-colors duration-200 hover:bg-[#1D140B]">
        <Menu size={22} strokeWidth={1.6} />
      </button>
      <div data-testid="side-menu-overlay" onClick={() => setOpen(false)}
        className={`fixed inset-0 z-50 bg-black/60 backdrop-blur-sm transition-opacity duration-300 ${open ? "opacity-100" : "pointer-events-none opacity-0"}`} />
      <aside data-testid="side-menu" aria-hidden={!open}
        className={`fixed inset-y-0 left-0 z-50 flex w-80 flex-col border-r border-[#E6A45D]/30 bg-[#0d0a07] p-6 pt-[calc(var(--safe-top)+24px)] transition-transform duration-300 ease-out ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="flex items-center justify-between">
          <img src="/img/logo.webp" alt="enjoythismoment" className="h-14 w-auto" />
          <button data-testid="side-menu-close" aria-label="Fermer le menu" onClick={() => setOpen(false)} className="flex h-10 w-10 items-center justify-center rounded-full border border-[#E6A45D]/40 text-[#F8C872] hover:bg-[#1D140B]"><X size={18} /></button>
        </div>
        <nav className="mt-10 flex flex-col gap-1">
          {LINKS.map(([id, label, to, I, end]) => (
            <NavLink key={id} to={to} end={end} data-testid={`side-menu-${id}`}
              className={({ isActive }) => `flex items-center gap-4 rounded-[14px] px-4 py-3.5 text-sm transition-colors duration-200 ${isActive ? "bg-[#1D140B] text-[#F8C872]" : "text-[#F7F4EE]/85 hover:bg-[#15110C]"}`}>
              <I size={18} strokeWidth={1.6} className="text-[#E6A45D]" />{label}
            </NavLink>
          ))}
        </nav>
        <p className="mt-auto text-[10px] uppercase tracking-[0.25em] text-[#F6D7A1]/50">Event &amp; Instant</p>
      </aside>
    </div>
  );
};
